import React from 'react';

const UserGuideModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '16px',
          maxWidth: '900px',
          width: '100%',
          maxHeight: '85vh',
          overflow: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '24px', borderBottom: '2px solid #e2e8f0' }}>
          <h2 style={{ margin: 0, color: 'var(--deep-blue)' }}>📚 Emit User Guide</h2>
        </div>
        <div style={{ padding: '32px', lineHeight: '1.8' }}>
          <h3>🎯 What is Emit?</h3>
          <p>Emit is a transformation engine that helps you apply biblical wisdom through the Free Happy One (FHO) framework.</p>
          
          <h3>🏃 The Three MindStreams</h3>
          <p><strong>⚡ POWER (I THEE)</strong> - Your relationship with God: Bible Study, Prayer, Worship</p>
          <p><strong>🌊 FLOW (I ME)</strong> - Your internal transformation: Self-reflection, Meditation</p>
          <p><strong>👁️ CLARITY (I WE)</strong> - Your external expression: Service, Teaching</p>
          
          <h3>📊 Consciousness Points Formula</h3>
          <p>Points = Duration × Quality Rating (1-10) / 10 × Streak Bonus (1 + streak × 0.05)</p>
          
          <h3>💡 Tips for Success</h3>
          <ul>
            <li>Start small: 10 minutes/day is better than 0</li>
            <li>Be consistent: Daily practice beats occasional marathons</li>
          </ul>
          
          <button
            onClick={onClose}
            style={{
              marginTop: '24px',
              padding: '12px 24px',
              background: 'var(--primary-blue)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserGuideModal;
